import { useUserLanguage } from '@/customHooks';
import { ContractStatusOption } from '@/graphql/generated';
import { FC } from 'react';
import styled from 'styled-components';

type ContractStatusPillProps = {
  status: ContractStatusOption
}

const PillContainer = styled.div<{ $color: string, $backgroundColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: bold;
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

const statusMapping = (status: ContractStatusOption, language: 'es' | 'en') => {
  const mapping = {
    en: {
      BOOKING: {
        text:'Booking',
        color: {
          font: '#FF971D',
          background: '#FF971D21'
        },
      },
      CANCELED: {
        text:'Canaceled',
        color: {
          font: '#ff7878',
          background: '#ffd7d7'
        },
      },
      EXPIRED:  {
        text:'Expired',
        color: {
          font: '#808080',
          background: '#ECECEC'
        },
      },
      INITIATED: {
        text:'Initiated',
        color: {
          font: '#4a9462',
          background: '#d2f3dc'
        },
      },
      NOT_ISSUED: {
        text:'Not Issued',
        color: {
          font: '#ff7878',
          background: '#ffd7d7'
        },
      },
    },
    es: {
      BOOKING: {
        text:'Reservado',
        color: {
          font: '#FF971D',
          background: '#FF971D21'
        },
      },
      CANCELED: {
        text:'Canacelado',
        color: {
          font: '#ff7878',
          background: '#ffd7d7'
        },
      },
      EXPIRED:  {
        text:'Expirado',
        color: {
          font: '#808080',
          background: '#ECECEC'
        },
      },
      INITIATED: {
        text:'Iniciado',
        color: {
          font: '#4a9462',
          background: '#d2f3dc'
        },
      },
      NOT_ISSUED: {
        text:'No Enviado',
        color: {
          font: '#ff7878',
          background: '#ffd7d7'
        },
      },
    },
  }

  return mapping[language][status]
} 

export const ContractStatusPill: FC<ContractStatusPillProps> = ({ status }) => {
  const userLanguage = useUserLanguage()

  const statusMapped = statusMapping(status, userLanguage)
  return (
    <PillContainer $color={statusMapped.color.font} $backgroundColor={statusMapped.color.background}>
      {statusMapped.text}
    </PillContainer>
  );
}